import React from 'react';
import styled, { keyframes } from 'styled-components';

const wave = keyframes`
  0%, 100% {
    opacity: 0.2;
    transform: translateY(0) scale(0.65);
  }
  50% {
    opacity: 1;
    transform: translateY(-30%) scale(1);
  }
`;

const StyledWrapper = styled.span<{ $size: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: ${({ $size }) => $size};
  gap: calc(${({ $size }) => $size} * 0.25);
`;

const StyledDot = styled.span<{
  $dotSize: string;
  $color: string;
  $delay: string;
}>`
  width: ${({ $dotSize }) => $dotSize};
  height: ${({ $dotSize }) => $dotSize};
  border-radius: 50%;
  background: ${({ $color }) => $color};
  animation: ${wave} 1.4s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay};
`;

type Props = {
  size?: string;
  color?: string;
};

export function Spinner({
  size = '1.25rem',
  color = 'currentColor',
}: Readonly<Props>) {
  const dotSize = `calc(${size} * 0.32)`;

  return (
    <StyledWrapper $size={size}>
      <StyledDot $dotSize={dotSize} $color={color} $delay="0s" />
      <StyledDot $dotSize={dotSize} $color={color} $delay="0.16s" />
      <StyledDot $dotSize={dotSize} $color={color} $delay="0.32s" />
    </StyledWrapper>
  );
}
